import { mdiChevronRight } from '@mdi/js';
import Icon from '@mdi/react';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { steps } from '../../../components/Wizard';
import useWizardContext from '../../../hooks/useWizardContext';
import { FreeSlot } from '../../../types/FreeSlot';
import { Store } from '../../../types/Store';
import { formatDate } from '../../../utils/formatDateAndTime';
import classes from '../classes.module.css';
import trackABTestingStep from '../../../utils/trackABTestingSteps';
import Timeslot from './Timeslot';

const TimeslotSelector: React.FC<{
  date: Date;
  slots: FreeSlot[] | null | undefined;
  store: Store;
}> = ({ date, slots, store }) => {
  const intl = useIntl();
  const { setStore, setStoreSlot, setStep } = useWizardContext();
  const [selectedSlot, setSelectedSlot] = useState<FreeSlot | null>(null);

  // const handleClick = React.useCallback(
  //   (store: Store) => () => {
  //     if (!store.isEbookingEnabled && store.ctaUrl) {
  //       window.location.href = store.ctaUrl;
  //     } else {
  //       setStore(store);
  //       setStep((prev) => (prev + 1) as WizardStep);
  //     }
  //   },
  //   [setStep, setStore],
  // );
  const stepMax = (window as any).maxStep ?? 5;

  const handleSelectSlot = React.useCallback(
    (slot: FreeSlot) => () => {
      setSelectedSlot(slot);
      trackABTestingStep(stepMax == 5 ? 3.1 : 2.1);
    },
    [setSelectedSlot],
  );

  const handleConfirmSlot = React.useCallback(() => {
    setStore(store);
    setStoreSlot(selectedSlot);
    setStep(steps.personalInfo);
  }, [selectedSlot, setStep, setStore, setStoreSlot, store]);

  return (
    <div className={classes.timeslotSelectorWrapper}>
      {/* <div>{intl.formatMessage({ id: 'timeslot.availableTimes' })}</div> */}
      <div className={classes.timeslotInfo}>
        <p>{intl.formatMessage({ defaultMessage: 'Kies een tijdstip', id: 'timeslot.chooseATime' })}</p>
        <p> {formatDate(intl.locale, date)}</p>
      </div>
      <div className={classes.radioToolbar}>
        <div className={classes.data}>
          <div className={classes.wrapper}>
            {slots &&
              slots.map((slot) => (
                <Timeslot key={slot.startDateTime} slot={slot} handleSelect={handleSelectSlot(slot)} />
              ))}
          </div>
        </div>

        <div className={classes.selectButtonWrapper}>
          {selectedSlot ? (
            <button type='button' className={classes.selectButton} onClick={handleConfirmSlot}>
              {intl.formatMessage({ defaultMessage: 'Afspraak maken ', id: 'timeslot.selectTimeslot' })}
              <Icon path={mdiChevronRight} size='22px' />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

TimeslotSelector.displayName = 'TimeslotSelector';

export default TimeslotSelector;

// const today = new Date();
// const createSlide = (offset: number): { date: Date; key: string } => {
//   const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + offset, 12, 0, 0);
//   return { date, key: date.toISOString().split('T')[0] };
// };

// const formatDate = (locale: string, date: Date) => date.toLocaleDateString(locale, {});

// const formatSelectedSlot = (locale: string, d: Date) => {
//   const time = d.toLocaleTimeString(locale, {
//     hour: 'numeric',
//     hour12: false,
//     minute: '2-digit',
//   });

//   const day = d.toLocaleDateString(locale, {
//     weekday: 'long',
//   });

//   const date = d.toLocaleDateString(locale, {
//     day: 'numeric',
//     month: 'long',
//   });

//   return `${time}, ${day}, ${date}`;
// };
